import axios from 'axios'
import Cookies from 'js-cookie'

import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'

class BaseTracking extends BaseComponent {
  init () {
    this.loadScript().then(() => {
      this.callRichRelevance()
    })
  }

  async getPlacements () {
    const modularElement = document.querySelector('[data-modular-content-id]')

    if (modularElement) {
      const modularId = modularElement.dataset.modularContentId
      const endpoint = `${window.env && window.env.baseHost}/api/boitata/v1/modularContents/${modularId}/recommendedProducts`

      return axios.get(endpoint)
    }
  }

  getData () {
    return this.$element.data()
  }

  loadScript () {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')

      script.src = '//media.richrelevance.com/rrserver/js/1.2/p13n.js'
      script.onload = resolve
      script.onerror = reject

      document.body.appendChild(script)
    })
  }

  getDataFromCookie () {
    return {
      userId: Cookies.get('user_id') || '',
      userTrackingId: Cookies.get('user_tracking_id') || ''
    }
  }

  async callRichRelevance () {
    const R3_COMMON = new r3_common() // eslint-disable-line
    const data = this.getData()

    if (!data) {
      return
    }

    R3_COMMON.setApiKey(data.apiKey)
    R3_COMMON.setBaseUrl(data.baseUrl)

    const dataFromCookie = this.getDataFromCookie()

    R3_COMMON.setSessionId(dataFromCookie.userTrackingId)
    R3_COMMON.setClickthruServer(window.location.protocol + '//' + window.location.host)
    R3_COMMON.setRegionId(data.regionId)

    if (dataFromCookie.userId) {
      R3_COMMON.setUserId(dataFromCookie.userId)
    }

    try {
      const { data } = await this.getPlacements()

      data.forEach(component => {
        R3_COMMON.addPlacementType(component.data.placement)
      })
    } catch (err) {
      if (err.response?.status !== 404) {
        console.error(err)
      }
    }

    this.sendItems(data, R3_COMMON)

    RR.jsonCallback = function () {
      emitter.emit('recommendation', RR.data.JSON.placements)
    }

    rr_flush_onload()
    r3()
  }
}

export default BaseTracking
